import { render, staticRenderFns } from "./AllegacyOnboardingInfo.vue?vue&type=template&id=3ae0201a"
import script from "./AllegacyOnboardingInfo.vue?vue&type=script&lang=ts"
export * from "./AllegacyOnboardingInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports